import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "m-costcalc-dialog section items-start" }
const _hoisted_3 = {
  key: 0,
  class: "m-costcalc-dialog__wrapper"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("rect", {
  x: "0",
  y: "1",
  rx: "3",
  ry: "3",
  width: "55",
  height: "5"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("rect", {
  x: "0",
  y: "9",
  rx: "3",
  ry: "3",
  width: "40",
  height: "5"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("rect", {
  x: "0",
  y: "18",
  rx: "3",
  ry: "3",
  width: "50",
  height: "30"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("rect", {
  x: "55",
  y: "18",
  rx: "3",
  ry: "3",
  width: "45",
  height: "30"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M10.836 7.75l4.297-4.297a1.276 1.276 0 000-1.89l-.945-.946a1.276 1.276 0 00-1.891 0L8 4.914 3.66.617a1.276 1.276 0 00-1.89 0l-.946.946a1.276 1.276 0 000 1.89L5.121 7.75.824 12.09a1.276 1.276 0 000 1.89l.946.946a1.276 1.276 0 001.89 0L8 10.629l4.297 4.297a1.276 1.276 0 001.89 0l.946-.946a1.276 1.276 0 000-1.89l-4.297-4.34z" })
], -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "m-costcalc-dialog__wrapper"
}
const _hoisted_11 = { class: "m-costcalc-dialog__header row spacing-bottom-2-xs" }
const _hoisted_12 = { class: "col-xs-12" }
const _hoisted_13 = { class: "editable-header spacing-right-2-sm" }
const _hoisted_14 = { class: "m-costcalc-dialog__columns row justify-content-between-xs align-left-xs" }
const _hoisted_15 = { class: "col-md-6 col-xs-12" }
const _hoisted_16 = { class: "m-costcalc-dialog__col m-costcalc-dialog__col--greenwheels" }
const _hoisted_17 = { class: "spacing-bottom-2-xs editable-header" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "m-costcalc-dialog__car m-costcalc-dialog__car--greenwheels" }, null, -1)
const _hoisted_19 = { class: "m-costcalc-dialog__cartitle" }
const _hoisted_20 = { class: "a-toggle-costcalc" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("input", {
  type: "checkbox",
  name: "",
  id: "result1",
  value: ""
}, null, -1)
const _hoisted_22 = {
  class: "a-toggle-costcalc__label",
  for: "result1"
}
const _hoisted_23 = { class: "a-toggle-costcalc__label--closed" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8 .25A7.749 7.749 0 00.25 8 7.749 7.749 0 008 15.75 7.749 7.749 0 0015.75 8 7.749 7.749 0 008 .25zm4.5 8.625a.38.38 0 01-.375.375H9.25v2.875a.38.38 0 01-.375.375h-1.75a.361.361 0 01-.375-.375V9.25H3.875a.361.361 0 01-.375-.375v-1.75a.38.38 0 01.375-.375H6.75V3.875a.38.38 0 01.375-.375h1.75c.188 0 .375.188.375.375V6.75h2.875c.188 0 .375.188.375.375v1.75z" })
], -1)
const _hoisted_25 = { class: "a-toggle-costcalc__label--open" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8 .25A7.749 7.749 0 00.25 8 7.749 7.749 0 008 15.75 7.749 7.749 0 0015.75 8 7.749 7.749 0 008 .25zm-4.125 9a.361.361 0 01-.375-.375v-1.75a.38.38 0 01.375-.375h8.25c.188 0 .375.188.375.375v1.75a.38.38 0 01-.375.375h-8.25z" })
], -1)
const _hoisted_27 = { class: "a-toggle-costcalc__wrapper" }
const _hoisted_28 = { class: "hide--mobile hide--tablet" }
const _hoisted_29 = { class: "a-table-costcalc" }
const _hoisted_30 = { class: "strong" }
const _hoisted_31 = { class: "strong" }
const _hoisted_32 = { class: "strong" }
const _hoisted_33 = { class: "strong" }
const _hoisted_34 = { class: "hide--desktop" }
const _hoisted_35 = { class: "hide--mobile hide--tablet" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("svg", {
  class: "a-button__icon",
  viewBox: "0 0 24 24",
  width: "24",
  height: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M17.53 13.012c.626-.56.626-1.465 0-2.024L10.736 4.92c-.626-.559-1.64-.559-2.266 0-.625.559-.625 1.464 0 2.023L14.133 12l-5.664 5.058c-.625.558-.625 1.464 0 2.023.626.559 1.64.559 2.266 0l6.796-6.07z"
  })
], -1)
const _hoisted_37 = { class: "m-costcalc-dialog__aside col-md-6 col-xs-12" }
const _hoisted_38 = { class: "m-costcalc-dialog__col" }
const _hoisted_39 = { class: "spacing-bottom-2-xs editable-header" }
const _hoisted_40 = { class: "m-costcalc-dialog__car" }
const _hoisted_41 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 100 100",
  focusable: "false"
}
const _hoisted_42 = /*#__PURE__*/_createStaticVNode("<path fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M68.39 40.64c-.69-.21-1.28.21-1.53.9l-.58 2.17c-.21.73.47 1.57 1.22 1.57\"></path><path d=\"M29.69 61.21a5.853 5.853 0 01-5.84 5.47c-3.11 0-5.65-2.42-5.84-5.47-.01-.13-.01-.25-.01-.38 0-1.06.28-2.06.78-2.92a5.862 5.862 0 0110.15 0c.5.86.78 1.86.78 2.92-.01.13-.01.25-.02.38zm-3.44-.38c0-1.32-1.08-2.4-2.4-2.4a2.4 2.4 0 00-2.4 2.4c0 1.32 1.08 2.4 2.4 2.4 1.32 0 2.4-1.08 2.4-2.4zm59.81.38a5.853 5.853 0 01-5.84 5.47c-3.11 0-5.65-2.42-5.84-5.47-.01-.13-.01-.25-.01-.38 0-1.06.28-2.06.78-2.92a5.862 5.862 0 0110.15 0c.5.86.78 1.86.78 2.92-.01.13-.01.25-.02.38zm-3.44-.38c0-1.32-1.08-2.4-2.4-2.4a2.4 2.4 0 00-2.4 2.4c0 1.32 1.08 2.4 2.4 2.4 1.32 0 2.4-1.08 2.4-2.4zm0 0\" fill=\"currentColor\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M47.11 33.32L47.1 44.5l22.88.86s2.56.18 2.56-2.31\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M47.11 33.32L47.1 44.5l-20.02-.59s-.54-10.05 8.43-10.6\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M91.61 46.98c-2.96-1.23-11.43-2.29-14.78-2.68-3.35-.39-5.58-2.01-5.58-2.01s-5.19-2.9-9.87-5.86c-4.69-2.96-8.7-3.12-8.7-3.12H35.95c-4.35 0-7.14 1.28-7.14 1.28l-14.67 6.64H6.05c-2.68 0-2.4 2.45-2.4 2.45v5.63s-1.3 1.62-1.3 3.51.12 2.82 1.3 3.77c1.17.95 9.38 2.4 9.38 2.4l1.19 1.56h1.54c.14-4.35 3.69-7.85 8.08-7.85s7.94 3.49 8.08 7.85h40.21c.14-4.35 3.69-7.85 8.08-7.85 4.39 0 7.94 3.49 8.08 7.85h7.43s1.91.13 1.91-1.97v-4.87c.01-4-3.06-5.5-6.02-6.73zm-40.84.45l3.07.08m-23.79-.68l3.07.08\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M94.37 48.26l-3.62-.2c-.89-.14-1.4.56-1.08 1.25.74 1.58.99 1.58 1.64 1.63l4.71.24h.64\"></path>", 6)
const _hoisted_48 = [
  _hoisted_42
]
const _hoisted_49 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 100 100",
  focusable: "false"
}
const _hoisted_50 = /*#__PURE__*/_createStaticVNode("<path fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M67.81 41.86c-.66-.2-1.24.2-1.48.87l-.57 1.9c-.2.71.46 1.52 1.18 1.52\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M45.91 34.66v10.42l-10.44-.43c-4.29-2.66-2.87-9.8-2.87-9.8m37.97 8.98c0 2.48-1.66 2.42-1.66 2.42l-23-1.18V34.66\"></path><path d=\"M28.54 60.28a5.853 5.853 0 01-5.84 5.47c-3.11 0-5.65-2.42-5.84-5.47-.01-.13-.01-.25-.01-.38 0-1.06.28-2.06.78-2.92a5.862 5.862 0 0110.15 0c.5.86.78 1.86.78 2.92 0 .13-.01.26-.02.38zm-3.44-.38c0-1.32-1.08-2.4-2.4-2.4a2.4 2.4 0 00-2.4 2.4c0 1.32 1.08 2.4 2.4 2.4 1.33 0 2.4-1.07 2.4-2.4zm54.16.38a5.853 5.853 0 01-5.84 5.47c-3.11 0-5.65-2.42-5.84-5.47-.01-.13-.01-.25-.01-.38 0-1.06.28-2.06.78-2.92a5.862 5.862 0 0110.15 0c.5.86.78 1.86.78 2.92-.01.13-.02.26-.02.38zm-3.44-.38c0-1.32-1.08-2.4-2.4-2.4a2.4 2.4 0 00-2.4 2.4c0 1.32 1.08 2.4 2.4 2.4a2.4 2.4 0 002.4-2.4zm0 0\" fill=\"currentColor\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M70.57 43.83l-7.77-5.54c-4.17-3.03-7.94-3.37-7.94-3.37-14.17-1.66-31.19.29-31.19.29s-.8.17-2.14.31c-1.34.14-.31 1.29-.49 1.97-.17.69-5.99 5.71-7.71 7.83-1.71 2.11-1.49 4.46-1.49 4.46v6.3l1.45 3.83h1.31c0-4.48 3.63-8.1 8.11-8.1 4.48 0 8.11 3.63 8.11 8.1h34.5c0-4.48 3.63-8.1 8.11-8.1 4.48 0 8.11 3.63 8.11 8.1h4.76c1.94 0 1.89-2.34 1.89-2.34v-6.13c-2.48-7.04-17.62-7.61-17.62-7.61zm-21.72 4.18l3.07.14m-15.26-.74l3.07.14\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M85.88 48.26l-3.62-.2c-.89-.14-1.4.56-1.08 1.25.74 1.58.99 1.58 1.64 1.63l4.71.24h.64\"></path>", 5)
const _hoisted_55 = [
  _hoisted_50
]
const _hoisted_56 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 100 100",
  focusable: "false"
}
const _hoisted_57 = /*#__PURE__*/_createStaticVNode("<path d=\"M31.27 60.1a5.853 5.853 0 01-5.84 5.47c-3.11 0-5.65-2.42-5.84-5.47-.01-.13-.01-.25-.01-.38 0-1.06.28-2.06.78-2.92a5.862 5.862 0 0110.15 0c.5.86.78 1.86.78 2.92 0 .13-.01.26-.02.38zm-3.44-.38c0-1.32-1.08-2.4-2.4-2.4a2.4 2.4 0 00-2.4 2.4c0 1.32 1.08 2.4 2.4 2.4 1.33 0 2.4-1.07 2.4-2.4zm49.02.38a5.853 5.853 0 01-5.84 5.47c-3.11 0-5.65-2.42-5.84-5.47-.01-.13-.01-.25-.01-.38 0-1.06.28-2.06.78-2.92a5.862 5.862 0 0110.15 0c.5.86.78 1.86.78 2.92-.01.13-.01.26-.02.38zm-3.44-.38c0-1.32-1.08-2.4-2.4-2.4a2.4 2.4 0 00-2.4 2.4c0 1.32 1.08 2.4 2.4 2.4a2.4 2.4 0 002.4-2.4zm0 0\" fill=\"currentColor\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M62.39 41.35c-.66-.2-1.24.2-1.48.87l-.57 1.9c-.2.71.46 1.52 1.18 1.52m-19.46-8.77v7.84l-5.2-.44-5.15-1.37s-2.83-.21-2.37-3.19l.47-4.52\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M42.06 34.43v10.29l21.31 1.03s1.66.06 1.66-2.42\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M76.07 45.24c-3.11-1.04-11.04-1.91-11.04-1.91s-2.81-2.29-7.2-5.04c-4.38-2.75-11.39-3.86-17.67-3.86-6.28 0-14.59 1.37-14.59 1.37s-3.29-.01-4.02-.01c-.73 0-.26.81-.26.81l1.28 1.25s-2.57 2.9-3.71 4.22c-1.14 1.32-1.03 2.79-1.06 4.96-.04 2.16-.51 3.19-1.43 4.36-.92 1.17-1.03 2.79-1.03 2.79v2.42c0 1.25 1.92 3.13 1.92 3.13 0-4.48 3.63-8.11 8.11-8.11 4.48 0 8.11 3.63 8.11 8.11h29.41c0-4.48 3.63-8.11 8.11-8.11 4.48 0 8.11 3.63 8.11 8.11h5.55V52.4c-.01-2.37-5.45-6.12-8.59-7.16zm-31.44 2.58l3.07.16\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M81.46 48.26l-3.62-.2c-.89-.14-1.4.56-1.08 1.25.74 1.58.99 1.58 1.64 1.63l4.71.24h.64\"></path>", 5)
const _hoisted_62 = [
  _hoisted_57
]
const _hoisted_63 = { class: "m-costcalc-dialog__cartitle" }
const _hoisted_64 = { class: "a-toggle-costcalc" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("input", {
  type: "checkbox",
  name: "",
  id: "result2",
  value: ""
}, null, -1)
const _hoisted_66 = {
  class: "a-toggle-costcalc__label",
  for: "result2"
}
const _hoisted_67 = { class: "a-toggle-costcalc__label--closed" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8 .25A7.749 7.749 0 00.25 8 7.749 7.749 0 008 15.75 7.749 7.749 0 0015.75 8 7.749 7.749 0 008 .25zm4.5 8.625a.38.38 0 01-.375.375H9.25v2.875a.38.38 0 01-.375.375h-1.75a.361.361 0 01-.375-.375V9.25H3.875a.361.361 0 01-.375-.375v-1.75a.38.38 0 01.375-.375H6.75V3.875a.38.38 0 01.375-.375h1.75c.188 0 .375.188.375.375V6.75h2.875c.188 0 .375.188.375.375v1.75z" })
], -1)
const _hoisted_69 = { class: "a-toggle-costcalc__label--open" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8 .25A7.749 7.749 0 00.25 8 7.749 7.749 0 008 15.75 7.749 7.749 0 0015.75 8 7.749 7.749 0 008 .25zm-4.125 9a.361.361 0 01-.375-.375v-1.75a.38.38 0 01.375-.375h8.25c.188 0 .375.188.375.375v1.75a.38.38 0 01-.375.375h-8.25z" })
], -1)
const _hoisted_71 = { class: "a-toggle-costcalc__wrapper" }
const _hoisted_72 = { class: "hide--mobile hide--tablet" }
const _hoisted_73 = { class: "a-table-costcalc" }
const _hoisted_74 = { class: "strong" }
const _hoisted_75 = { class: "strong" }
const _hoisted_76 = { class: "strong" }
const _hoisted_77 = { class: "strong" }
const _hoisted_78 = { class: "strong" }
const _hoisted_79 = { class: "strong" }
const _hoisted_80 = { class: "hide--mobile hide--tablet" }
const _hoisted_81 = { class: "hide--desktop spacing-top-2-xs" }
const _hoisted_82 = { class: "m-costcalc-dialog__info" }
const _hoisted_83 = { class: "m-costcalc-dialog__footer row spacing-top-2-xs" }
const _hoisted_84 = { class: "col-xs-12" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("svg", {
  class: "a-button__icon",
  viewBox: "0 0 24 24",
  width: "24",
  height: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M17.53 13.012c.626-.56.626-1.465 0-2.024L10.736 4.92c-.626-.559-1.64-.559-2.266 0-.625.559-.625 1.464 0 2.023L14.133 12l-5.664 5.058c-.625.558-.625 1.464 0 2.023.626.559 1.64.559 2.266 0l6.796-6.07z"
  })
], -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M10.836 7.75l4.297-4.297a1.276 1.276 0 000-1.89l-.945-.946a1.276 1.276 0 00-1.891 0L8 4.914 3.66.617a1.276 1.276 0 00-1.89 0l-.946.946a1.276 1.276 0 000 1.89L5.121 7.75.824 12.09a1.276 1.276 0 000 1.89l.946.946a1.276 1.276 0 001.89 0L8 10.629l4.297 4.297a1.276 1.276 0 001.89 0l.946-.946a1.276 1.276 0 000-1.89l-4.297-4.34z" })
], -1)
const _hoisted_87 = [
  _hoisted_86
]
const _hoisted_88 = {
  key: 2,
  class: "m-costcalc-dialog__wrapper"
}
const _hoisted_89 = { class: "m-costcalc-dialog__header row spacing-bottom-2-xs" }
const _hoisted_90 = { class: "col-xs-12" }
const _hoisted_91 = { class: "editable-header spacing-right-2-xs" }
const _hoisted_92 = { class: "m-costcalc-dialog__columns row justify-content-between-xs align-left-xs" }
const _hoisted_93 = { class: "col-md-6 col-xs-12" }
const _hoisted_94 = { class: "m-costcalc-dialog__col m-costcalc-dialog__col--content" }
const _hoisted_95 = { key: 0 }
const _hoisted_96 = { class: "a-list" }
const _hoisted_97 = { class: "m-costcalc-dialog__aside col-md-6 col-xs-12" }
const _hoisted_98 = { class: "m-costcalc-dialog__col m-costcalc-dialog__col--highlight" }
const _hoisted_99 = { class: "spacing-bottom-2-xs editable-header" }
const _hoisted_100 = { class: "hide--mobile hide--tablet" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("svg", {
  class: "a-button__icon",
  viewBox: "0 0 24 24",
  width: "24",
  height: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M17.53 13.012c.626-.56.626-1.465 0-2.024L10.736 4.92c-.626-.559-1.64-.559-2.266 0-.625.559-.625 1.464 0 2.023L14.133 12l-5.664 5.058c-.625.558-.625 1.464 0 2.023.626.559 1.64.559 2.266 0l6.796-6.07z"
  })
], -1)
const _hoisted_102 = { class: "m-costcalc-dialog__footer row spacing-top-2-xs" }
const _hoisted_103 = { class: "col-xs-12" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("svg", {
  class: "a-button__icon",
  viewBox: "0 0 24 24",
  width: "24",
  height: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M17.53 13.012c.626-.56.626-1.465 0-2.024L10.736 4.92c-.626-.559-1.64-.559-2.266 0-.625.559-.625 1.464 0 2.023L14.133 12l-5.664 5.058c-.625.558-.625 1.464 0 2.023.626.559 1.64.559 2.266 0l6.796-6.07z"
  })
], -1)
const _hoisted_105 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M10.836 7.75l4.297-4.297a1.276 1.276 0 000-1.89l-.945-.946a1.276 1.276 0 00-1.891 0L8 4.914 3.66.617a1.276 1.276 0 00-1.89 0l-.946.946a1.276 1.276 0 000 1.89L5.121 7.75.824 12.09a1.276 1.276 0 000 1.89l.946.946a1.276 1.276 0 001.89 0L8 10.629l4.297 4.297a1.276 1.276 0 001.89 0l.946-.946a1.276 1.276 0 000-1.89l-4.297-4.34z" })
], -1)
const _hoisted_106 = [
  _hoisted_105
]
const _hoisted_107 = /*#__PURE__*/_createElementVNode("div", { class: "m-costcalc-dialog__bg js-close-dialog" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_content_loader = _resolveComponent("content-loader")!

  return ((_ctx.loading || _ctx.costs) && !_ctx.error)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_content_loader, { viewBox: "0 0 100 50" }, {
                  default: _withCtx(() => [
                    _hoisted_4,
                    _hoisted_5,
                    _hoisted_6,
                    _hoisted_7
                  ]),
                  _: 1
                }),
                _createElementVNode("button", {
                  class: "close-button js-close-dialog",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.previousStep && _ctx.previousStep(...args)))
                }, _hoisted_9)
              ]))
            : (_ctx.costs && _ctx.costs.CostResults && _ctx.costs.CostResults.IsSubscriptionCheaperThanOwnCar)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("h2", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t("subscription-cheaper-title-begin")) + " ", 1),
                          _createElementVNode("strong", null, _toDisplayString(_ctx.costs.CostResults.DifferenceCostsPercentage) + "% " + _toDisplayString(_ctx.$t("cheaper")), 1),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("subscription-cheaper-title-end")), 1)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _createElementVNode("h3", _hoisted_19, [
                            _createTextVNode(_toDisplayString(_ctx.$t("subscription-costs-begin")) + " ", 1),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.costs.CostResults.DifferenceCostsFormatted), 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("subscription-costs-end")), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _hoisted_21,
                          _createElementVNode("label", _hoisted_22, [
                            _createElementVNode("span", _hoisted_23, [
                              _hoisted_24,
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("button-view")) + " " + _toDisplayString(_ctx.$t("costs-structure")), 1)
                            ]),
                            _createElementVNode("span", _hoisted_25, [
                              _hoisted_26,
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("button-hide")) + " " + _toDisplayString(_ctx.$t("costs-structure")), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("p", null, [
                                _createElementVNode("strong", null, _toDisplayString(_ctx.$t("subscription-costs-text")), 1)
                              ])
                            ]),
                            _createElementVNode("table", _hoisted_29, [
                              _createElementVNode("tbody", null, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", null, _toDisplayString(_ctx.$t("hours-driven")) + ":", 1),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.costs.SubscriptionCosts.HoursFormatted), 1)
                                  ])
                                ]),
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", null, _toDisplayString(_ctx.$t("amount-of-kilometers")) + ":", 1),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.costs.SubscriptionCosts.KilometersFormatted), 1)
                                  ])
                                ]),
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", null, _toDisplayString(_ctx.$t("hour-costs")) + ":", 1),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.costs.SubscriptionCosts.HourCostsFormatted), 1)
                                  ])
                                ]),
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", null, _toDisplayString(_ctx.$t("kilometer-costs")) + ":", 1),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.costs.SubscriptionCosts.KilometerCostsFormatted), 1)
                                  ])
                                ]),
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", null, _toDisplayString(_ctx.$t("your-subscription")) + ":", 1),
                                  _createElementVNode("td", null, _toDisplayString(_ctx.costs.SubscriptionCosts.Name), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("p", null, _toDisplayString(_ctx.costs.SubscriptionCosts.CostsCombinationText), 1),
                            _createElementVNode("small", _hoisted_34, _toDisplayString(_ctx.$t("calculation-disclaimer")), 1),
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("a", {
                                href: "#",
                                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.subscribe && _ctx.subscribe(...args))),
                                class: "a-button a-button--primary a-button--fullwidth a-button--icon"
                              }, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t("button-subscribe")), 1),
                                _hoisted_36
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            (_ctx.costs.OwnCarCosts.CarSize === 'midrange')
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_41, _hoisted_48))
                              : (_ctx.costs.OwnCarCosts.CarSize === 'small-midrange')
                                ? (_openBlock(), _createElementBlock("svg", _hoisted_49, _hoisted_55))
                                : (_openBlock(), _createElementBlock("svg", _hoisted_56, _hoisted_62))
                          ]),
                          _createElementVNode("h3", _hoisted_63, [
                            _createTextVNode(_toDisplayString(_ctx.$t("own-car-costs")) + " ", 1),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.costs.OwnCarCosts.TotalCostsFormatted) + " " + _toDisplayString(_ctx.$t("per-year")), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_64, [
                          _hoisted_65,
                          _createElementVNode("label", _hoisted_66, [
                            _createElementVNode("span", _hoisted_67, [
                              _hoisted_68,
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("button-view")) + " " + _toDisplayString(_ctx.$t("costs-structure")), 1)
                            ]),
                            _createElementVNode("span", _hoisted_69, [
                              _hoisted_70,
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("button-hide")) + " " + _toDisplayString(_ctx.$t("costs-structure")), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_71, [
                            _createElementVNode("div", _hoisted_72, [
                              _createElementVNode("p", null, [
                                _createElementVNode("strong", null, _toDisplayString(_ctx.$t("own-car-costs-text")), 1)
                              ])
                            ]),
                            _createElementVNode("table", _hoisted_73, [
                              _createElementVNode("tbody", null, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", null, _toDisplayString(_ctx.$t("own-car-type")) + ":", 1),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.getCarSizeTranslation(_ctx.costs.OwnCarCosts.CarSize)), 1)
                                  ])
                                ]),
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", null, _toDisplayString(_ctx.$t("deprication")) + ":", 1),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.costs.OwnCarCosts.DepricationCostsFormatted), 1)
                                  ])
                                ]),
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", null, _toDisplayString(_ctx.$t("fuel")) + ":", 1),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("span", _hoisted_76, _toDisplayString(_ctx.costs.OwnCarCosts.FuelCostsFormatted), 1)
                                  ])
                                ]),
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", null, _toDisplayString(_ctx.$t("maintenance")) + ":", 1),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.costs.OwnCarCosts.MaintenanceCostsFormatted), 1)
                                  ])
                                ]),
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", null, _toDisplayString(_ctx.$t("insurance")) + ":", 1),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.costs.OwnCarCosts.InsuranceCostsFormatted), 1)
                                  ])
                                ]),
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", null, _toDisplayString(_ctx.$t("tax")) + ":", 1),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("span", _hoisted_79, _toDisplayString(_ctx.costs.OwnCarCosts.TaxCostsFormatted), 1)
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_80, [
                              _createElementVNode("p", null, [
                                _createElementVNode("a", {
                                  href: "#",
                                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.previousStep && _ctx.previousStep(...args))),
                                  class: "a-costcalc__updatelink"
                                }, _toDisplayString(_ctx.$t("change-input")), 1)
                              ])
                            ]),
                            _createElementVNode("small", null, _toDisplayString(_ctx.$t("own-car-costs-explanation")), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_81, [
                          _createElementVNode("div", _hoisted_82, [
                            _createElementVNode("p", null, [
                              _createTextVNode(_toDisplayString(_ctx.$t("subscription-costs-text-mobile")) + " ", 1),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.costs.SubscriptionCosts.KilometersFormatted) + _toDisplayString(_ctx.$t("kilometers-unit")), 1),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t("and")) + " ", 1),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.costs.SubscriptionCosts.HoursFormatted) + " " + _toDisplayString(_ctx.$t("hours-driven-mobile")), 1)
                            ]),
                            _createElementVNode("p", null, [
                              _createElementVNode("a", {
                                href: "#",
                                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.previousStep && _ctx.previousStep(...args))),
                                class: "a-costcalc__updatelink"
                              }, _toDisplayString(_ctx.$t("change-input")), 1)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_83, [
                    _createElementVNode("div", _hoisted_84, [
                      _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.subscribe && _ctx.subscribe(...args))),
                        class: "a-button a-button--primary a-button--fullwidth a-button--icon"
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("button-subscribe")), 1),
                        _hoisted_85
                      ])
                    ])
                  ]),
                  _createElementVNode("button", {
                    class: "close-button js-close-dialog",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.previousStep && _ctx.previousStep(...args)))
                  }, _hoisted_87)
                ]))
              : (_ctx.costs && _ctx.costs.CostResults && !_ctx.costs.CostResults.IsSubscriptionCheaperThanOwnCar)
                ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                    _createElementVNode("div", _hoisted_89, [
                      _createElementVNode("div", _hoisted_90, [
                        _createElementVNode("div", _hoisted_91, [
                          _createElementVNode("h2", null, [
                            _createTextVNode(_toDisplayString(_ctx.$t("own-car-cheaper-title")) + " ", 1),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.$t("cheaper")), 1)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_92, [
                      _createElementVNode("div", _hoisted_93, [
                        _createElementVNode("div", _hoisted_94, [
                          _createElementVNode("p", null, _toDisplayString(_ctx.$t("own-car-cheaper-body-intro")), 1),
                          (_ctx.cons.length > 0)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_95, _toDisplayString(_ctx.$t("own-car-cheaper-body-cons")), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("ul", _hoisted_96, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cons, (item) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: item,
                                class: "a-list__item"
                              }, _toDisplayString(item), 1))
                            }), 128))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_97, [
                        _createElementVNode("div", _hoisted_98, [
                          _createElementVNode("div", _hoisted_99, [
                            _createElementVNode("h3", null, [
                              _createTextVNode(_toDisplayString(_ctx.$t("own-car-cheaper-subtitle-greenwheels")) + " ", 1),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.$t("own-car-cheaper-subtitle-soms")), 1)
                            ])
                          ]),
                          _createElementVNode("p", null, _toDisplayString(_ctx.$t("own-car-cheaper-body-end")), 1),
                          _createElementVNode("div", _hoisted_100, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.subscribe && _ctx.subscribe(...args))),
                              class: "a-button a-button--primary a-button--fullwidth a-button--icon"
                            }, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("button-subscribe-soms")), 1),
                              _hoisted_101
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_102, [
                      _createElementVNode("div", _hoisted_103, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.subscribe && _ctx.subscribe(...args))),
                          class: "a-button a-button--primary a-button--fullwidth a-button--icon"
                        }, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("button-subscribe")), 1),
                          _hoisted_104
                        ])
                      ])
                    ]),
                    _createElementVNode("button", {
                      class: "close-button js-close-dialog",
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.previousStep && _ctx.previousStep(...args)))
                    }, _hoisted_106)
                  ]))
                : _createCommentVNode("", true)
        ]),
        _hoisted_107
      ]))
    : _createCommentVNode("", true)
}